import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import { useWindowSize } from '@app/hooks';
import { useBrandsHeader } from '@app/pages/Warehouses/Brands/hooks';

export const BrandsHeader = () => {
  const { goToAddBrand, IsBrandCreate } = useBrandsHeader();
  const { isMobile } = useWindowSize();

  if (!IsBrandCreate) {
    return null;
  }

  return (
    <Button
      className={isMobile ? 'full-width' : ''}
      type="primary"
      onClick={goToAddBrand}
      icon={<PlusOutlined />}
    >
      Добавить бренд
    </Button>
  );
};
